import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useState } from "react";
import { designTokens, Modal, Text } from "@cinch-labs/design-system";
import { useMediaQuery } from "react-responsive";
import { getVehiclesApi } from "./compare-bar-provider.helpers";
var initialVehiclesValue = [];
var initialExpandedValue = {
    isExpanded: true
};
export var CompareBarContext = /*#__PURE__*/ createContext(undefined);
export var setStorage = function(key, data, store) {
    var hasWindow = "object" !== "undefined";
    var getStorage = function(store) {
        return store !== null && store !== void 0 ? store : window.sessionStorage;
    };
    if (hasWindow) {
        getStorage(store).setItem(key, JSON.stringify(data));
    }
};
export var CompareBarProvider = function(param) {
    var children = param.children;
    var isViewportMediumOrLarger = useMediaQuery({
        query: designTokens.customMedia.l
    });
    var maxNumberOfItems = isViewportMediumOrLarger ? 3 : 2;
    var ref = useState(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = useState(false), compareBarSticky = ref1[0], setCompareBarSticky = ref1[1];
    var ref2 = useState({}), vehicleSummaryMap = ref2[0], setVehicleSummaryMap = ref2[1];
    var ref3 = useState(false), customerHasActiveOrder = ref3[0], setCustomerHasActiveOrder = ref3[1];
    var ref4 = useState(function() {
        if ("object" === "undefined") {
            return initialExpandedValue;
        }
        try {
            var item = sessionStorage.getItem("compare-bar");
            return item ? JSON.parse(item) : initialExpandedValue;
        } catch (e) {
            return initialExpandedValue;
        }
    }), compareBarSessionData = ref4[0], setCompareBarSessionData = ref4[1];
    var ref5 = useState(function() {
        if ("object" === "undefined") {
            return initialVehiclesValue;
        }
        try {
            var item = localStorage.getItem("compare-bar");
            if (item) {
                var parsedItem = JSON.parse(item);
                return Array.isArray(parsedItem) ? parsedItem : initialVehiclesValue;
            }
            return initialVehiclesValue;
        } catch (e) {
            //datadogRum.addError(error)
            return initialVehiclesValue;
        }
    }), comparisonVehicles = ref5[0], setCompareBarData = ref5[1];
    var addVehicle = function(param) {
        var vehicleId = param.vehicleId, vehicleImage = param.vehicleImage, vehicleTitle = param.vehicleTitle, vehicleMake = param.vehicleMake, vehicleModel = param.vehicleModel;
        var vehicleExists = comparisonVehicles.some(function(vehicle) {
            return vehicle.vehicleId === vehicleId;
        });
        if (vehicleExists) return;
        var vehicleData = {
            vehicleId: vehicleId,
            vehicleImage: vehicleImage,
            vehicleTitle: vehicleTitle,
            vehicleMake: vehicleMake,
            vehicleModel: vehicleModel
        };
        setCompareBarData(_to_consumable_array(comparisonVehicles).concat([
            vehicleData
        ]));
    };
    var removeVehicle = function(vehicleId) {
        var currentVehicles = comparisonVehicles.filter(function(vehicle) {
            return vehicle.vehicleId !== vehicleId;
        });
        setCompareBarData(currentVehicles);
    };
    var handleModalClosure = function() {
        setShowModal(false);
    };
    useEffect(function() {
        setStorage("compare-bar", comparisonVehicles, localStorage);
    }, [
        comparisonVehicles
    ]);
    useEffect(function() {
        setStorage("compare-bar", compareBarSessionData, sessionStorage);
    }, [
        compareBarSessionData
    ]);
    useEffect(function() {
        if (comparisonVehicles.length > maxNumberOfItems) {
            removeVehicle(comparisonVehicles[comparisonVehicles.length - 1].vehicleId);
        }
    }, [
        maxNumberOfItems
    ]);
    useEffect(function() {
        var vehicleIds = comparisonVehicles.map(function(vehicle) {
            return vehicle.vehicleId;
        });
        if (comparisonVehicles.length === 0) return;
        getVehiclesApi({
            vehicleIds: vehicleIds.join(",")
        }).then(function(param) {
            var data = param.data;
            var vehicleListings = data.vehicleListings;
            var vehicleSummaryMap = vehicleListings.reduce(function(acc, vehicle) {
                acc[vehicle.vehicleId] = {
                    isAvailable: vehicle.isAvailable
                };
                return acc;
            }, {});
            setVehicleSummaryMap(vehicleSummaryMap);
        });
    }, []);
    return /*#__PURE__*/ _jsxs(CompareBarContext.Provider, {
        value: {
            comparisonVehicles: comparisonVehicles,
            compareBarExpanded: compareBarSessionData.isExpanded,
            compareBarSticky: compareBarSticky,
            vehicleSummaryMap: vehicleSummaryMap,
            addVehicle: addVehicle,
            removeVehicle: removeVehicle,
            setCompareBarExpanded: function(value) {
                return setCompareBarSessionData({
                    isExpanded: value
                });
            },
            setCompareBarSticky: setCompareBarSticky,
            setShowModal: setShowModal,
            maxNumberOfItems: maxNumberOfItems,
            showModal: showModal,
            customerHasActiveOrder: customerHasActiveOrder,
            setCustomerHasActiveOrder: setCustomerHasActiveOrder
        },
        children: [
            showModal && /*#__PURE__*/ _jsx(Modal, {
                heading: "Your compare list is full",
                ariaLabelledById: "compare-list-full",
                onClose: handleModalClosure,
                children: /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "m",
                    children: [
                        "You can only compare ",
                        maxNumberOfItems,
                        " cars at a time. Remove a car from your compare list to add this one in."
                    ]
                })
            }),
            children
        ]
    });
};
export var useCompareBar = function() {
    var context = useContext(CompareBarContext);
    if (context === undefined) {
        throw new Error("useCompareBar must be used within a CompareBarProvider");
    }
    return context;
};
